import React, {useState, useEffect } from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
 

const StkPushRequestEdit = ()=>{
     const [timeIn, setTimeIn ] = useState('');
     const [phoneNumber, setPhoneNumber ] = useState('');
     const [amount, setAmount ] = useState('');
     const [mpesaReceiptNumber, setMpesaReceiptNumber ] = useState('');
     const [resultDesc, setResultDesc ] = useState('');
     const [misc5, setMisc5 ] = useState('');
    const [redirect, setRedirect] = useState(false);
 

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`stkPushRequest/${id}`);
                 setTimeIn(data.time_in);
                 setPhoneNumber(data.phone_number);
                 setAmount(data.amount);
                 setMpesaReceiptNumber(data.mpesa_receipt_number);
                 setResultDesc(data.result_desc);
                 setMisc5(data.misc5);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`stkPushRequest/${id}`, {
            timeIn,
            phoneNumber,
            amount,
            mpesaReceiptNumber,
            resultDesc,
            misc5,
        });
        console.log(data);
        setRedirect(true);
    };
   
    if(redirect){
         return <Navigate to={'/stkPushRequest'} />
    }
    return (
        <Wrapper pageTitle={'Edit StkPushRequest'}>
            <InnerNav createLink={'/stkPushRequestCreate'} listLink={'/stkPushRequest'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TimeIn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TimeIn" value={timeIn}
                        onChange = {e => setTimeIn(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">PhoneNumber </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="PhoneNumber" value={phoneNumber}
                        onChange = {e => setPhoneNumber(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount" value={amount}
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">MpesaReceiptNumber </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="MpesaReceiptNumber" value={mpesaReceiptNumber}
                        onChange = {e => setMpesaReceiptNumber(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ResultDesc </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ResultDesc" value={resultDesc}
                        onChange = {e => setResultDesc(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Misc5 </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Misc5" value={misc5}
                        onChange = {e => setMisc5(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default StkPushRequestEdit;